import { useTransitionStatus } from '@floating-ui/react';
import { useMediaQuery } from 'react-responsive';
import '../components/theme/index.js';
import { useTheme } from '../components/theme/use_theme.js';

const usePreferredTransitionStatus = (context, { duration } = {}) => {
    const { variables } = useTheme();
    const prefersReducedMotion = useMediaQuery({ query: variables.media.reducedMotion });
    return useTransitionStatus(context, {
        duration: prefersReducedMotion ? 0 : duration,
    });
};

export { usePreferredTransitionStatus };
